import { Component, Input, ViewChild } from '@angular/core';
import { ApiKeysModalComponent } from '../../../features/api-keys-modal/api-keys-modal.component';

@Component({
  selector: 'app-api-access-card',
  templateUrl: './api-access-card.component.html',
  styleUrls: ['./api-access-card.component.scss'],
  standalone: false,
})
export class ApiAccessCardComponent {
  @Input() isExpanded: boolean = true;
  @ViewChild('apiKeysModal') apiKeysModal!: ApiKeysModalComponent;

  openApiKeysModal(): void {
    this.apiKeysModal?.open();
  }
}


